import fr from 'facet-rest';
import BaseOverride from './BaseOverride';

const FamilyMemberDetailOverride = fr.metaOverride({ base: BaseOverride });

export default FamilyMemberDetailOverride;
